import Vue from 'vue'
import Vuex from 'vuex'
import Http from '@/http/index'
import getCurrentCityName from "@/getCurrentCityName";
import crypto from '@/crypto/crypto'

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        lang: 'zh',
        alterIndex: '',
        NavigationList: [],
        userInfos: localStorage.getItem("userInfos") ? JSON.parse(crypto.get(localStorage.getItem("userInfos"))) : '',
        theme_color: localStorage.getItem("theme_color") ? JSON.parse(crypto.get(localStorage.getItem("theme_color"))) : '',

        uuid: null,//设备唯一码
        network: null,//网络
        wificode: null,//wificode
        latlon: null,//经纬度
        ip: null,//网络ip

        page: 1,
        PuserSearch: {
            member_id: localStorage.getItem("userInfoMemberId") ?
                JSON.parse(crypto.get(localStorage.getItem("userInfoMemberId"))).member_id ?
                    JSON.parse(crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : null : null,
            library_id: localStorage.getItem("theme_color") ?(
                JSON.parse(crypto.get(localStorage.getItem("theme_color"))).number_id ?
                    JSON.parse(crypto.get(localStorage.getItem("theme_color"))).number_id : 28) : 28,
            content: '',
            terminal_type: 16,//终端类型 1 书籍app 2文库app 3书籍小程序 4书籍墨水屏 5朗读亭 6系统管理端 7自助借还机 8微型图书馆 9书籍查阅机 10电子阅读机 11文库墨水屏 12文库小程序  13阿启泰有声读物小程序 14优质资源 15蒙医药 16图书馆只能同意检索系统
            type: '',//类型 类型 1书籍 2素材 3文库 4期刊 5视频 6作者 7报刊
            wificode: '',
            devicecode: navigator.userAgent,
            network: '',
            latlon: localStorage.getItem("latlon") ? JSON.parse(localStorage.getItem("latlon")).latlon ? JSON.parse(localStorage.getItem("latlon")).latlon : '' : '',
            path: '',
            name: '',
            lang: 'zh',
            ip: '',//网络ip
        },

        SearchClass: {
            typeClass: '',
            qActive: '',
            searchContent: '',
            press_id: ''
        }
    },
    mutations: {
        //语言
        SET_LANG: (state, lang) => {
            state.lang = lang
        },
        //导航的索引
        SET_AlterIndex: (state, alterIndex) => {
            state.alterIndex = alterIndex
        },
        //导航的列表
        SET_Navigation: (state, NavigationList) => {
            state.NavigationList = NavigationList
        },
        //用户信息
        SET_UserInfor: (state, userInfos) => {
            state.userInfos = userInfos
        },
        SET_theme_color: (state, theme_color) => {
            state.theme_color = theme_color
        },
        // 赋值设备唯一码
        SET_CROWDCLASS: (state, uuid) => {
            state.uuid = uuid
        },
        // 赋值网络
        SET_NETWORK: (state, network) => {
            state.network = network
        },
        // 赋值网络ip
        SET_Ip: (state, ip) => {
            state.ip = ip
        },
        // 赋值wificode
        SET_WIFICODE: (state, wificode) => {
            state.wificode = wificode
        },
        // 赋值经纬度
        SET_LATLON: (state, latlon) => {
            state.latlon = latlon
        },
        SET_PAGE: (state, page) => {
            state.page = page
        },
        SET_PuserSearch: (state, [PuserSearch, path, name, type]) => {
            state.PuserSearch.content = PuserSearch
            state.PuserSearch.path = path
            state.PuserSearch.name = name
            state.PuserSearch.type = type
        },
        SET_SearchClass: (state, SearchClass) => {
            state.SearchClass = SearchClass
        }
    },
    getters: {
        lang: state => state.lang,
        alterIndex: state => state.alterIndex,
        NavigationList: state => state.NavigationList,
        userInfos: state => state.userInfos,
        theme_color: state => state.theme_color,

        uuid: state => state.uuid,
        network: state => state.network,
        wificode: state => state.wificode,
        latlon: state => state.latlon,
        ip: state => state.ip,
        page: state => state.page,
        PuserSearch: state => state.PuserSearch,
        SearchClass:state => state.SearchClass

    },
    actions: {
        /*****************************************************************
         *
         * 获取设备唯一码
         *
         *****************************************************************/
        getSebeihao({commit}) {
            commit('SET_CROWDCLASS', navigator.userAgent)
        },
        getNetworkType({commit}) {
            if (navigator.onLine) {
                commit('SET_NETWORK', 3)
            } else {
                commit('SET_NETWORK', 1)
            }
        },
        getMap({commit}) {
            getCurrentCityName().then(city => {

                if (city) {
                    var x = city.point.lng - 0.0065, y = city.point.lat - 0.006;
                    let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
                    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
                    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
                    var gcjLon = z * Math.cos(theta);
                    var gcjLat = z * Math.sin(theta);
                    let latlon = gcjLat + ',' + gcjLon
                    commit('SET_LATLON', latlon)
                    let ln = {
                        latlon: latlon
                    }
                    localStorage.setItem("latlon", JSON.stringify(ln));
                }

            })
        },

        /*****************************************************************
         *
         * 検索记録
         *
         *****************************************************************/
        getHedcircle({state}) {
            state.PuserSearch.library_id = localStorage.getItem("theme_color") ?(
                JSON.parse(crypto.get(localStorage.getItem("theme_color"))).number_id ?
                    JSON.parse(crypto.get(localStorage.getItem("theme_color"))).number_id : 28) : 28,
            state.PuserSearch.lang = localStorage.getItem("lang")


            Http.post('api/web/v1/search/searchadd', state.PuserSearch).then(val => {
            }).catch(err => {
            })
        },
    }


})
